import React, { Component } from "react";
import { MuiGrid, MuiButton, MuiTypography, MuiTextField, MuiDivider, MuiDateRange, MuiPaper } from "../../../ui/MaterialUIComponents";
import AssignTeacherForSubjectComponent from "./AssignTeacherForSubjectComponent";
import { WeeklyAvailabilityScheduleUtil } from "../../weeklyAvailability"
import theme from "../../../../assests/theme";
import lodashUtil from "lodash";
import { toast } from 'react-toastify';
import spinner from "../../../ui/icons/spinner.gif"
import { gradePickerUtil } from "../../gradePicker";
import * as StringReplacer from '../../../../i18n/StringReplacer'
import { ValidationUtil } from '../schoolInformation'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import RadioButtonComponent from "./RadioButtonComponent";
import { Radio } from '../../../ui/customUIComponents'
import * as Constants from '../../../../constants';
import AlertDialogComponent from "./AlertDialogComponent";
import { muiWithStyles } from '../../../ui/MaterialUIComponents';
import { initWeeklyAvailability } from '../../../functional/weeklyAvailability/WeeklyAvailabilityScheduleUtil';


const useStyles = theme => ({
  number: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  }
})

export class AddNewTeacherComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      toggleChange: false,
      assignedSubjects: undefined,
      isScheduleOpen: false,
      weeklyAvailabilitySchedule: [
        { id: 1, weekDays: [], outFrom: "", outUntill: "", outFromStr: "", outUntillStr: "" }
      ],
      isPreferredPeriod: false,
      sectionDisabled: true,
      gradeDisabled: true,
      gradeLevelDisabled: true,
      classTeacher: {
        isClassTeacher: false,
        gradeName: undefined,
        groupName: undefined,
        gradeLevel: undefined
      },
      gradeLevelArray: [],
      gradesArray: [],
      groupsArray: [],
      errors: [],
      weeklyAvailability: JSON.parse(JSON.stringify(this.props.teacher.weeklyAvailability)),
      phoneNumber: "",
      phoneNumberError: "",
      teacher: {},
      isSaved: false
    };
  }

  componentWillMount() {
    let classTeacher;
    let sectionDisabled = false;
    let gradeDisabled = false;
    let gradeLevelDisabled = false;
    if (this.props.teacher != undefined) {
      let teacher = this.props.teacher
      this.setState({
        teacher: teacher
      })
    }
    if (this.props.teacher.classTeacher != undefined) {
      classTeacher = JSON.parse(JSON.stringify(this.props.teacher.classTeacher));
    }
    let gradeLevelArray = this.props.activeSchool.school_master.gradeLevels
    if (classTeacher !== undefined) {
      if (classTeacher.isClassTeacher === true) {
        if (classTeacher.gradeLevel === undefined || classTeacher.gradeLevel === "") {
          sectionDisabled = false;
          gradeDisabled = false;
          gradeLevelDisabled = false;
        }
      } else {
        sectionDisabled = true;
        gradeDisabled = true;
        gradeLevelDisabled = true;
      }

      let gradesArray = this.state.gradesArray
      let groupsArray = this.state.groupsArray
      gradeLevelArray.map((levelObj) => {
        if (levelObj.levelName === classTeacher.gradeLevel) {
          gradesArray = levelObj.grades
        }
      })
      gradesArray.map((gradeObj) => {
        if (gradeObj.gradeName === classTeacher.gradeName) {
          groupsArray = gradeObj.groups
        }
      })
      this.setState({
        sectionDisabled: sectionDisabled,
        gradeDisabled: gradeDisabled,
        gradeLevelDisabled: gradeLevelDisabled,
        classTeacher: classTeacher,
        gradesArray: gradesArray,
        groupsArray: groupsArray,
      })
    }
    if (this.state.weeklyAvailability.availableForAllHours !== "true" && this.state.weeklyAvailability.availableForAllHours !== true) {
      this.state.weeklyAvailability.availableForAllHours = "false"
      this.state.weeklyAvailabilitySchedule = WeeklyAvailabilityScheduleUtil.destructorOfWeeklyAvailabilitySchedule(this.state.weeklyAvailability)
      let weeklyAvailabilityDisplay = WeeklyAvailabilityScheduleUtil.constructWeeklyAvailability(this.state.weeklyAvailabilitySchedule)
      this.state.weeklyAvailability.unAvailableDuration = weeklyAvailabilityDisplay.weeklyAvailabilityList
      this.state.weeklyAvailabilityDisplayList = weeklyAvailabilityDisplay.weeklyAvailabilityDisplayList
    } else {
      this.state.weeklyAvailability.availableForAllHours = "true"
    }
    if (this.props.teacher.assignedSubjects != undefined) {
      let assignedSubjects = [];
      assignedSubjects = JSON.parse(JSON.stringify(this.props.teacher.assignedSubjects));
      this.setState({
        assignedSubjects: assignedSubjects,
        isOpen: true
      });
    }
  }

  componentDidMount() {
    let gradeLevelArray = this.props.activeSchool.school_master.gradeLevels
    this.setState({
      gradeLevelArray: gradeLevelArray
    })
  }
  renderAddSubjectRow = () => {
    let assignedSubjects = this.state.assignedSubjects;
    if (assignedSubjects.length === 0) {
      assignedSubjects = []
    }
    assignedSubjects.push({
      id: assignedSubjects.length + 1,
      subjectName: null,
      isMainTeacher: true,
      isFixedTeacher: true,
      gradeDetails: {
        allGrades: false,
        gradeLevels: [],
        grades: []
      }
    });

    this.setState({
      assignedSubjects: assignedSubjects
    });
    this.updateData()
  };

  renderAvailabilityScheduleRow = () => {
    let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule;
    let initObj = initWeeklyAvailability();
    weeklyAvailabilitySchedule.push({
      id: weeklyAvailabilitySchedule.length + 1,
      weekDays: [], ...initObj

    });
    this.setState({
      weeklyAvailabilitySchedule: weeklyAvailabilitySchedule
    });
  };


  onClickOfAssign = () => {
    if (this.state.assignedSubjects === undefined) {
      let assignedSubjects = [
        {
          id: 1,
          subjectName: null,
          isMainTeacher: true,
          isFixedTeacher: true,
          gradeDetails: {
            allGrades: false,
            gradeLevels: [],
            grades: []
          }
        }
      ]
      this.setState({ assignedSubjects: assignedSubjects })
    }
    let isOpen = this.state.isOpen;
    if (this.props.teacher.assignedSubjects != undefined) {
      let assignedSubjects = this.props.teacher.assignedSubjects;
      this.setState({
        assignedSubjects: assignedSubjects,
        isOpen: !isOpen
      });
    } else {
      this.setState({
        isOpen: !isOpen
      });
    }
    this.updateData()
  };

  handleOnChange = (name, event) => {
    if (name === "email") {
      this.props.teacher[name] = event.target.value.trim()
    } else {
      this.props.teacher[name] = event.target.value
    }
    this.updateData()
    this.setState({
      toggleChange: !this.state.toggleChange
    });
  };

  handleChangeForPhoneNumber = (event, data, name) => {
    let teacher = JSON.parse(JSON.stringify(this.props.teacher))
    teacher[name] = event;
    teacher[name + "Val"] = event.replace(/[^0-9]+/g, '').slice(data.dialCode.length)
    this.updateData()
    this.setState({
      teacher: teacher
    })
  }

  handleChangeForClassTeacherButton = (event, value) => {
    let classTeacher = JSON.parse(JSON.stringify(this.state.classTeacher));
    if (value === 'true') {
      classTeacher.isClassTeacher = true
      this.setState({
        gradeLevelDisabled: false,
        sectionDisabled: false,
        gradeDisabled: false,
      })
    } else {
      classTeacher.isClassTeacher = false
      classTeacher.gradeLevel = 'Any'
      classTeacher.gradeName = 'Any'
      classTeacher.groupName = 'Any'
      this.setState({
        sectionDisabled: true,
        gradeDisabled: true,
        gradeLevelDisabled: true,
      })
    }
    this.updateData()
    this.setState({
      classTeacher: classTeacher
    })
  }

  handleChangeOfRadioButton = event => {
    this.state.weeklyAvailability["availableForAllHours"] = event.target.value;
    if (event.target.value == "true") {
      this.state.weeklyAvailability["unAvailableDuration"] = []
      let weeklyAvailabilitySchedule = []
      this.setState({
        isScheduleOpen: false,
        weeklyAvailabilitySchedule: weeklyAvailabilitySchedule,
        weeklyAvailabilityDisplayList: []
      });
    } else {
      let initObj = initWeeklyAvailability();
      this.setState({
        isScheduleOpen: true,
        weeklyAvailabilitySchedule: [
          { id: 1, weekDays: [], ...initObj }
        ]
      });
    }
    this.updateData()
  };

  onClickOfRadioButton = () => {
    this.setState({
      isScheduleOpen: true,
    });
  }

  onClickOfSaveInTeacherAvailabilitySchedule = () => {
    const i18n = this.props.i18n
    let validationFlag = false
    let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule
    for (let i = 0; i < weeklyAvailabilitySchedule.length; i++) {
      let weeklyAvailabilityScheduleObj = weeklyAvailabilitySchedule[i]
      if (weeklyAvailabilityScheduleObj.weekDays.length === 0) {
        toast(i18n.teachers.selectAtleastOneWeekDay)
        validationFlag = true
        break
      }
      if (weeklyAvailabilityScheduleObj.outFrom >= weeklyAvailabilityScheduleObj.outUntill) {
        toast(i18n.teachers.outuntillAfterOutfrom)
        validationFlag = true
        break
      }
    }

    if (validationFlag == false) {
      this.state.weeklyAvailability["availableForAllHours"] = "false"
      let weeklyAvailabilityDisplay = WeeklyAvailabilityScheduleUtil.constructWeeklyAvailability(this.state.weeklyAvailabilitySchedule)
      this.state.weeklyAvailability.unAvailableDuration = weeklyAvailabilityDisplay.weeklyAvailabilityList
      this.state.weeklyAvailabilityDisplayList = weeklyAvailabilityDisplay.weeklyAvailabilityDisplayList
      this.updateData()
      this.setState({
        isScheduleOpen: false
      });
    }
  };

  onClickOfCancelInTeacherAvailabilitySchedule = async () => {
    if (this.state.weeklyAvailabilitySchedule[0].weekDays.length === 0) {
      this.state.weeklyAvailability["availableForAllHours"] = "true"
    }
    else if (this.state.weeklyAvailability.unAvailableDuration == undefined || this.state.weeklyAvailability.unAvailableDuration.length === 0) {
      this.state.weeklyAvailability["availableForAllHours"] = "true"
    }
    if (this.state.weeklyAvailability["availableForAllHours"] === "true") {
      this.state.weeklyAvailability.unAvailableDuration = []
      this.state.weeklyAvailabilitySchedule = [
        { id: 1, weekDays: [] }
      ]
    }
    let weeklyAvailabilitySchedule = await WeeklyAvailabilityScheduleUtil.destructorOfWeeklyAvailabilitySchedule(this.state.weeklyAvailability)
    if (weeklyAvailabilitySchedule !== undefined) {
      let weeklyAvailabilityDisplay = WeeklyAvailabilityScheduleUtil.constructWeeklyAvailability(weeklyAvailabilitySchedule)
      this.state.weeklyAvailability.unAvailableDuration = weeklyAvailabilityDisplay.weeklyAvailabilityList
      this.state.weeklyAvailabilityDisplayList = weeklyAvailabilityDisplay.weeklyAvailabilityDisplayList
    }
    this.setState({
      weeklyAvailabilitySchedule: weeklyAvailabilitySchedule,
      isScheduleOpen: false,
    });
  };

  removeWeeklyAvailabilitySchedule = key => {
    let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule;
    if (weeklyAvailabilitySchedule.length === 1) {
      this.state.weeklyAvailability["availableForAllHours"] = "true"
      this.state.weeklyAvailability.unAvailableDuration = []
      let initObj = initWeeklyAvailability();
      this.setState({
        isScheduleOpen: false,
        weeklyAvailabilityDisplayList: undefined,
        weeklyAvailabilitySchedule: [
          { id: 1, weekDays: [], ...initObj }
        ]
      });
    } else {
      weeklyAvailabilitySchedule.splice(key, 1);
      this.setState({ weeklyAvailabilitySchedule: weeklyAvailabilitySchedule })
    };
    this.updateData()
  };

  onClickOfSave = async () => {
    const i18n = this.props.i18n
    let errors = [];
    let validationFlag = true
    let phoneNumberValidation = ValidationUtil.phoneNumberValidation(i18n, this.state.teacher.phoneNumberVal)
    if (this.props.teacher.firstName !== undefined) {
      if (!(this.props.teacher.firstName.trim()).match(/(^[a-zA-Z0-9_' ]{1,200}$)/)) {
        validationFlag = false
        errors["firstName"] = i18n.teachers.firstNameIsEmpty;
      }
    } else {
      validationFlag = false
      errors["firstName"] = i18n.teachers.firstNameIsEmpty;
    }
    if (this.props.teacher.lastName !== undefined) {
      if (!(this.props.teacher.lastName.trim()).match(/(^[a-zA-Z0-9_' ]{1,200}$)/)) {
        validationFlag = false
        errors["lastName"] = i18n.teachers.lastNameIsEmpty;
      }
    } else {
      validationFlag = false
      errors["lastName"] = i18n.teachers.lastNameIsEmpty;
    }

    if (this.props.teacher.maxTeachingHours !== undefined) {
      if (this.props.teacher.maxTeachingHours < 0) {
        validationFlag = false
        errors["maxTeachingHours"] = i18n.teachers.invalidTeachingHours;
      }
    } else {
      validationFlag = false
      errors["maxTeachingHours"] = i18n.teachers.maxTeachingHoursIsEmpty;
    }



    if (this.props.teacher.email != null && this.props.teacher.email.trim() != "") {
      if (!(this.props.teacher.email.trim()).match(/^([A-Za-z0-9\_\-\.])+\@([A-Za-z0-9\_\-\.])+\.([A-Za-z]{2,4})$/)) {
        validationFlag = false;
        errors["email"] = i18n.teachers.emailValidity;
      } else {
        let emailAlreadyExist = lodashUtil.find(this.props.activeSchool.school_master.teachers, ["email", this.props.teacher.email]);
        if (emailAlreadyExist != undefined) {
          if (this.props.teacher._id == null) {
            validationFlag = false;
            errors["email"] = i18n.teachers.teacherEmailIdAlreadyExist;
          }
          else if ((this.props.teacher._id != null) && (emailAlreadyExist._id != this.props.teacher._id)) {
            validationFlag = false;
            errors["email"] = i18n.teachers.teacherEmailIdAlreadyExist;
          }
        }
      }
    }
    this.setState({ errors: errors })
    if (this.state.teacher.phoneNumber !== undefined) {

    }
    if (this.state.assignedSubjects != null) {
      let subjectObject = lodashUtil.find(this.state.assignedSubjects, ["subjectName", null]);
      if (subjectObject != null) {
        toast(i18n.teachers.emptySubjectName);
        validationFlag = false
      }
      else {
        let subjects = this.state.assignedSubjects
        for (let i = 0; i < subjects.length - 1; i++) {
          for (let j = i + 1; j < subjects.length; j++) {
            if (subjects[i].subjectName === subjects[j].subjectName) {
              let subjectGradeDetailArray = gradePickerUtil.convertingGradeDetailsToLowestFormat(subjects[i].gradeDetails, this.props);
              let comparingGradeDetailArray = gradePickerUtil.convertingGradeDetailsToLowestFormat(subjects[j].gradeDetails, this.props);
              let differenceInGrades = lodashUtil.difference(subjectGradeDetailArray, comparingGradeDetailArray);
              if (differenceInGrades.length === 0) {
                validationFlag = false
                let errorMessage_repeatingSubjectName = StringReplacer.getFormatedMessage(i18n.subjects.repeatingSubjectName,
                  {
                    Subject: subjects[j].subjectName,
                  })
                toast(errorMessage_repeatingSubjectName);
                break;
              }
            }

          }
          if (validationFlag === false) {
            break;
          }
        }
      }

    }
    if (validationFlag === true && phoneNumberValidation.validation) {
      let id = this.props.teacher._id;
      let teachersArray = this.props.activeSchool.school_master.teachers
      let teacher = this.props.teacher;
      teacher.weeklyAvailability = this.state.weeklyAvailability
      if (this.state.assignedSubjects !== undefined) {
        teacher.assignedSubjects = this.state.assignedSubjects;
      }
      if (this.state.classTeacher && this.state.classTeacher.gradeLevel === "Any") {
        this.state.classTeacher.gradeLevel = undefined
      }
      if (this.state.classTeacher && this.state.classTeacher.gradeName === "Any") {
        this.state.classTeacher.gradeName = undefined
      }
      if (this.state.classTeacher && this.state.classTeacher.groupName === "Any") {
        this.state.classTeacher.groupName = undefined
      }
      let teacherInSchoolMaster = lodashUtil.find(teachersArray, ["_id", id]);
      if (teacherInSchoolMaster !== undefined) {
        if (teacher.teacherId === undefined) {
          if (teacherInSchoolMaster.firstName !== teacher.firstName
            || teacherInSchoolMaster.lastName !== teacher.lastName) {
            teacher.teacherId = this.generatingteacherId(this.props.teacher.firstName.trim(), this.props.teacher.lastName.trim());
          }
        }
      } else {
        if (teacher.teacherId === undefined) {
          teacher.teacherId = this.generatingteacherId(this.props.teacher.firstName.split(" ").join(""), this.props.teacher.lastName.split(" ").join(""));
        }
      }
      teacher.classTeacher = this.state.classTeacher
      teacher.phoneNumber = this.state.teacher.phoneNumber
      this.props.confirmationDialogTeacher.isChanged = false
      await this.props.onClickOfSave(teacher);

    }
    this.setState({
      phoneNumberError: phoneNumberValidation.phoneNumberError
    })

  };


  removeAssignedSubjectFromTeacher = (key) => {
    let assignedSubjects = JSON.parse(JSON.stringify(this.state.assignedSubjects));
    this.props.deleteAssignedSubjectFromRules(assignedSubjects[key], this.props.teacher, "deleteRules")
    assignedSubjects.splice(key, 1);
    this.setState({
      assignedSubjects: assignedSubjects
    })
    this.updateData()
  }
  //Generating teaches id by first or last name 
  generatingteacherId = (firstName, lastName) => {
    let teacherId;
    if (firstName != null && firstName.length >= 3) {
      teacherId = this.checkingTeacherIdExists(firstName);
    } else if (lastName != null && lastName.length >= 3) {
      teacherId = this.checkingTeacherIdExists(lastName);
    } else if (firstName !== null && lastName !== null && firstName !== undefined && lastName !== undefined) {
      let FnLn = firstName + lastName;
      teacherId = this.checkingTeacherIdExists(FnLn);
    }
    return teacherId;
  }

  // check if the teachers id exists.
  checkingTeacherIdExists = (name) => {
    let isIdTaken = undefined;
    let count = 0;
    let teacherId;
    let first3LettersOfName;
    let teachersArray = this.props.activeSchool.school_master.teachers;
    first3LettersOfName = name.substring(0, 3).toUpperCase();
    teacherId = first3LettersOfName;
    while (isIdTaken === undefined) {
      if (teachersArray.length === 0) { // if there is nothing to compare in the teachers array then just add the teachers id withouht any validations
        return teacherId;
      } else { //if there are teachers id int he array then have to comapre it.
        if (count != 0) {
          teacherId = (first3LettersOfName + count);
        }
        isIdTaken = lodashUtil.find(teachersArray, ['teacherId', teacherId]);
        if (isIdTaken === undefined) {
          return teacherId;
        } else {
          count++;
          isIdTaken = undefined;
        }
      }
    }
  }

  handleChangeForClassTeacher = (name, event) => {
    let classTeacher = JSON.parse(JSON.stringify(this.state.classTeacher))
    let gradeLevels = JSON.parse(JSON.stringify(this.state.gradeLevelArray))
    let gradesArray = JSON.parse(JSON.stringify(this.state.gradesArray))
    let groupsArray = JSON.parse(JSON.stringify(this.state.groupsArray))
    let gradeDisabled;
    let sectionDisabled;

    if (name === "gradeLevel") {
      if (classTeacher.gradeLevel !== event.target.value && event.target.value !== "Any") {
        classTeacher[name] = event.target.value
        classTeacher.gradeName = "Any"
        classTeacher.groupName = "Any"
      } else if (event.target.value === "Any") {
        classTeacher[name] = event.target.value
        classTeacher["gradeName"] = "Any";
        classTeacher["groupName"] = "Any"
        gradesArray = []
        groupsArray = []
      }
    } else if (name === "gradeName") {
      if (classTeacher.gradeName !== event.target.value && event.target.value !== "Any") {
        classTeacher[name] = event.target.value
        classTeacher.groupName = "Any"
        sectionDisabled = false
      } else if (event.target.value === "Any") {
        classTeacher[name] = event.target.value
        classTeacher["groupName"] = "Any"
        groupsArray = []
      }
    } else {
      classTeacher[name] = event.target.value
    }
    if (classTeacher.gradeLevel !== undefined && classTeacher.gradeLevel !== "Any" && classTeacher.gradeLevel !== "") {
      gradeLevels.map((levelObj) => {
        if (levelObj.levelName === classTeacher.gradeLevel) {
          gradesArray = levelObj.grades
        }
      })
    }
    if (classTeacher.gradeName !== undefined && classTeacher.gradeName !== "Any" && classTeacher.gradeName !== "") {
      sectionDisabled = false
      gradesArray.map((gradeObj) => {

        if (gradeObj.gradeName === classTeacher.gradeName) {
          groupsArray = gradeObj.groups
        }
      })
    }
    this.setState({
      classTeacher: classTeacher,
      gradesArray: gradesArray,
      groupsArray: groupsArray,
      gradeDisabled: gradeDisabled,
      sectionDisabled: sectionDisabled
    })
    this.updateData()
  }

  updateData = () => {
    if (!this.props.confirmationDialogTeacher.isChanged) {
      this.props.confirmationDialogTeacher.isChanged = true
    }
    this.setState({ toggleChange: !this.state.toggleChange });

  }
  componentWillUnmount = async () => {
    if (this.props.confirmationDialogTeacher.isChanged) {
      await this.beforeUnload()
    }
  }

  undoChanges = () => {
    this.props.confirmationDialogTeacher.isChanged = false
  }
  beforeUnload = async () => {
    const i18n = this.props.i18n
    var flag = window.confirm(i18n.teachers.msgForUnsavedChangesInTab);
    if (flag) {
      await this.onClickOfSave()
    }
    else {
      await this.undoChanges()
    }
  }

  cancelAddNewTeacher = async () => {
    this.state.isSaved = true
    await this.props.cancelAddNewTeacher()

  }
  render() {
    if (this.props.gradeMasterData.gradeLevel == undefined) {
      return <div><img src={spinner} alt="none" className={theme.spinnerImgStyle} /></div>
    }
    const { i18n, classes } = this.props
    return (
      <MuiGrid
        container
        xs={12}
        style={{ border: "1px solid " + theme.palette.grey.main, padding: "5px", paddingBottom: "10px" }}
      >

        <MuiGrid container xs={12} direction="row" justify="space-between" style={{ margin: "5px" }} >
          <MuiGrid container xs={12} direction="row" >
            <MuiGrid item container xs={6} style={{ paddingRight: 10 }}>
              <MuiGrid item xs={12}>
                <MuiTextField
                  id="firstName"
                  color="primary"
                  fullWidth
                  autoFocus
                  required
                  label={i18n.teachers.firstName}
                  variant="outlined"
                  value={this.props.teacher.firstName}
                  onChange={event => this.handleOnChange("firstName", event)}
                  margin="normal"
                />
              </MuiGrid>
              <MuiGrid container item justify="left" xs={4} >
                <MuiTypography align="left" color="error" variant="caption" >
                  {this.state.errors.firstName}
                </MuiTypography>
              </MuiGrid>
            </MuiGrid>
            <MuiGrid item container xs={6}  >
              <MuiGrid item xs={12}>
                <MuiTextField
                  id="lastName"
                  color="primary"
                  fullWidth
                  required
                  label={i18n.teachers.lastName}
                  variant="outlined"
                  value={this.props.teacher.lastName}
                  onChange={event => this.handleOnChange("lastName", event)}
                  margin="normal"
                />
              </MuiGrid>
              <MuiGrid item container xs={6} justify="left">
                <MuiTypography align="left" color="error" variant="caption">
                  {this.state.errors.lastName}
                </MuiTypography>
              </MuiGrid>
            </MuiGrid>
          </MuiGrid>

          <MuiGrid container xs={12} direction="row" justify="space-between" style={{ marginTop: "10px" }}>
            <MuiGrid item container xs={6} style={{ paddingRight: 10 }}>
              <MuiGrid item xs={12}>
                <PhoneInput
                  id="phone"
                  color="primary"
                  fullWidth
                  containerStyle={{ width: 100 }}
                  onChange={(event, data) => this.handleChangeForPhoneNumber(event, data, "phoneNumber")}
                  country={'us'}
                  style={theme.muiTextFieldStyleForMainScreen}
                  placeholder={i18n.commonTexts.phoneNumber}
                  value={this.state.teacher.phoneNumber}
                />
              </MuiGrid>
              <MuiGrid container item justify="left" xs={4} >
                <MuiTypography color="error" variant="caption">
                  {this.state.phoneNumberError}
                </MuiTypography>
              </MuiGrid>
            </MuiGrid>
            <MuiGrid item container xs={6}  >
              <MuiGrid item xs={12}>
                <MuiTextField
                  id="maxHours"
                  color="primary"
                  label={i18n.teachers.maxTeachingHours}
                  variant="outlined"
                  value={this.props.teacher.maxTeachingHours}
                  onChange={event => this.handleOnChange("maxTeachingHours", event)}
                  fullWidth
                  required
                  type="number"
                  className={classes.number}
                />
              </MuiGrid>
              <MuiGrid container item justify="left" xs={6} >
                <MuiTypography align="left" color="error" variant="caption" >
                  {this.state.errors.maxTeachingHours}
                </MuiTypography>
              </MuiGrid>
            </MuiGrid>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid container xs={12} direction="row" justify="space-between" style={{ margin: "5px" }} >

          <MuiGrid container xs={12} direction="row" style={{ border: "1px solid gray", marginTop: "10px", marginBottom: "10px" }} />
          <MuiGrid container xs={12} style={{ padding: "5px" }}>
            <MuiGrid container xs={12} direction="column" >
              <MuiGrid item xs={12} >
                <MuiTypography
                  // variant="subtitle2"
                  // gutterBottom
                  // style={theme.gridHeaderTextStyle}
                  // align="left"
                  style={theme.radioTitleStyle}
                >
                  {i18n.teachers.weeklyAvailability}
                </MuiTypography>
              </MuiGrid>
            </MuiGrid>

            <RadioButtonComponent
              {...this.props}
              {...this.state}
              handleChangeOfRadioButton={this.handleChangeOfRadioButton}
              onClickOfRadioButton={this.onClickOfRadioButton}
              renderAvailabilityScheduleRow={this.renderAvailabilityScheduleRow}
              onClickOfSaveInTeacherAvailabilitySchedule={this.onClickOfSaveInTeacherAvailabilitySchedule}
              onClickOfCancelInTeacherAvailabilitySchedule={this.onClickOfCancelInTeacherAvailabilitySchedule}
              removeWeeklyAvailabilitySchedule={this.removeWeeklyAvailabilitySchedule}
            />
          </MuiGrid>
        </MuiGrid>
        <MuiGrid container xs={12} direction="row" style={{ marginTop: "10px", marginBottom: "10px" }} />
        <MuiGrid container xs={12} direction="column" justify="flex-start" alignItems="baseline" >
          <MuiGrid item xs={12} style={{ marginBottom: "10px" }}>
            <MuiButton
              id='assign'
              style={theme.primaryButtonStyle}
              onClick={() => { this.onClickOfAssign() }}
            >
              {i18n.teachers.assignSubject}
            </MuiButton>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid container xs={12}>
          <MuiGrid item xs={12} direction="row" justify="center" alignItems="center">
            {this.state.isOpen ? (
              <AssignTeacherForSubjectComponent
                {...this.props}
                {...this.state}
                renderAddSubjectRow={this.renderAddSubjectRow}
                removeAssignedSubjectFromTeacher={this.removeAssignedSubjectFromTeacher}
                updateData={this.updateData}
              />
            ) : null}
          </MuiGrid>
        </MuiGrid>
        <MuiGrid container xs={12} direction="row" style={{ border: "1px solid gray", marginTop: "10px", marginBottom: "10px" }} />
        <MuiGrid container xs={12} style={{ padding: "5px", paddingBottom: "10px" }}>
          <MuiGrid container xs={12} direction="column">
            <MuiGrid item xs={12}>

              <MuiTypography style={theme.radioTitleStyle} >
                {i18n.teachers.canBeClassTeacher}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>
          {/*  is class teacher true or false and grades */}
          <MuiGrid container xs={12} direction="row" />
          <MuiGrid container xs={12} >

            {this.props.getGradesInProgress == true && this.props.getGradeMasterDataInProgress == true && (
              <img
                src={spinner}
                alt="none"
                style={theme.spinnerImgStyle}
              />
            )}
            <MuiGrid item xs={2} style={{ paddingTop: "5px" }} justify="flex-start" alignContent="flex-start" alignItems="flex-start">
              <Radio size="small"
                checked={this.state.classTeacher.isClassTeacher === false}
                onChange={(event) => this.handleChangeForClassTeacherButton(event, 'false')} />
              No
              <Radio size="small"
                checked={this.state.classTeacher.isClassTeacher === true}
                onChange={(event) => this.handleChangeForClassTeacherButton(event, 'true')} />
              Yes

            </MuiGrid>
            <MuiGrid item xs={9}>
              <MuiGrid container xs={12} direction="row" alignItems="flex-start" justify="flex-start">
                <MuiGrid item xs={3} >
                  {/* grade levels */}
                  <MuiTextField
                    style={{ width: "90%" }}
                    color="primary"
                    variant="outlined"
                    select
                    fullWidth
                    value={this.state.classTeacher.gradeLevel}
                    disabled={this.state.gradeLevelDisabled}
                    label={i18n.teachers.gradeLevel}
                    onChange={(event) => { this.handleChangeForClassTeacher('gradeLevel', event) }}
                    SelectProps={{
                      native: true,
                    }} >
                    <option >Any
                    </option>
                    {this.state.gradeLevelArray.map((gradeLevel) => <option
                      value={gradeLevel.levelName}>{gradeLevel.levelName}</option>)}}
               </ MuiTextField>
                </MuiGrid>
                {/* grades */}
                <MuiGrid item xs={3}>
                  <MuiTextField
                    id="maxHours"
                    color="primary"
                    disabled={this.state.gradeDisabled}
                    variant="outlined"
                    style={{ width: "90%" }}
                    select
                    value={this.state.classTeacher.gradeName}
                    onChange={(event) => { this.handleChangeForClassTeacher('gradeName', event) }}
                    fullWidth
                    label={i18n.teachers.grade}
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option
                      style={{
                        height: "6vh"
                      }}>Any
                    </option>
                    {this.state.gradesArray.map((grades) => <option
                      key={grades.gradeName}>{grades.gradeName}</option>)}
                  </ MuiTextField>
                </MuiGrid>
                <MuiGrid item xs={3}>
                  {/* Sections */}
                  <MuiTextField
                    style={{ width: "90%" }}
                    id="maxHours"
                    disabled={this.state.sectionDisabled}
                    color="primary"
                    value={this.state.classTeacher.groupName}
                    variant="outlined"
                    fullWidth
                    select
                    onChange={(event) => { this.handleChangeForClassTeacher('groupName', event) }}
                    label={i18n.teachers.section}
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option
                      style={{
                        height: "6vh"
                      }}>Any
                    </option>
                    {this.state.groupsArray.map((grade) => <option
                      key={grade.groupName}>{grade.groupName}</option>)}
                  </ MuiTextField>
                </MuiGrid>
              </MuiGrid>
              <MuiGrid>
              </MuiGrid>
            </MuiGrid>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid container xs={12} direction="row" justify="flex-end" >
          <MuiGrid item style={{ margin: "5px" }}>
            <MuiButton id="cancel" style={theme.secondaryButtonStyle} onClick={() => this.cancelAddNewTeacher()}>
              {" "}
              {i18n.commonTexts.cancel}
              {" "}
            </MuiButton>
          </MuiGrid>
          <MuiGrid item style={{ margin: "5px" }}>
            {this.props.updateSchoolinformationInProgress == true ?
              <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
              :
              <MuiButton
                id="save"
                disabled={!this.props.confirmationDialogTeacher.isChanged}
                style={!this.props.confirmationDialogTeacher.isChanged ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
                onClick={this.onClickOfSave}
              >
                {" "}
                {i18n.commonTexts.save}
                {" "}
              </MuiButton>
            }
          </MuiGrid>
        </MuiGrid>

      </MuiGrid >
    );
  }
}

export default muiWithStyles(useStyles)(AddNewTeacherComponent);
